const transactionCollectionAccordions = () => {
  const toggles = document.querySelectorAll('.js-transaction-accordion-expand-toggle');
  if (toggles) {
    for (let i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function(e) {
        e.preventDefault();
        const ariaControls = this.getAttribute('aria-controls');
        const target = document.getElementById(ariaControls);
        // toggle aria-expanded
        const ariaExpanded = this.getAttribute('aria-expanded');
        if (ariaExpanded === 'false') {
          this.setAttribute('aria-expanded', 'true');
        } else {
          this.setAttribute('aria-expanded', 'false');
        }
        if (target) {
          // toggle aria-hidden
          const ariaHidden = target.getAttribute('aria-hidden');
          if (ariaHidden === 'false') {
            target.setAttribute('aria-hidden', 'true');
          } else {
            target.setAttribute('aria-hidden', 'false');
          }
        }
      });
    }
  }
}
transactionCollectionAccordions();
